import { IRootReducer } from "../reducers";

export const getHasAccess = (state:IRootReducer) => state.auth.hasAccess;